import moment from "moment";

/**
 * @export
 * @class Helper
 * storage의 값을 가공·처리(값이 없을 때 예외처리)
 */
export default class Helper {
  /**
   * staticData 내의 값을 가공·처리
   */
  getStaticData() {
    const {
      deliveryInfo = null,
      contentInfo = null,
      refundInfo = null,
      localShopList = [],
    } = TMON.oApp.htStorage.htStaticData.htDealInfo;

    const refundType =
      refundInfo && refundInfo.refundType ? refundInfo.refundType : "";

    let { labelInfo = null } = TMON.oApp.htStorage.htStaticData.htDealInfo;

    TMON.oApp.htStorage.priceTypeText = "판매가";

    // labelInfo 없을 시 예외처리
    if (!labelInfo) {
      TMON.oApp.htStorage.htStaticData.htDealInfo.labelInfo = null;
      labelInfo = [];
    }

    /* deliveryInfo 관련 값 예외처리 및 재정의 */
    // deliveryInfo가 비어있을 때
    if (!deliveryInfo || Object.keys(deliveryInfo).length < 1) {
      TMON.oApp.htStorage.htStaticData.htDealInfo.deliveryInfo = {};
    }
    // 배송 정책에 따른 표시 문구 정의
    TMON.oApp.htStorage.htStaticData.htDealInfo.deliveryInfo.htRefinedDeliveryInfo = this.getRefinedDeliveryInfo(
      deliveryInfo,
      refundType
    );
    // 배송 정책에 따른 배송비 표시 문구 정의
    TMON.oApp.htStorage.htStaticData.htDealInfo.deliveryInfo.sRefinedDeliveryFeePolicyText = this.getRefinedDeliveryFeePolicy(
      deliveryInfo
    );
    // 예외배송 여부 저장
    TMON.oApp.htStorage.htStaticData.htDealInfo.deliveryInfo.bIsExceptionType =
      deliveryInfo &&
      deliveryInfo.deliveryType === "ED" &&
      deliveryInfo.deliveryProductType === "DP07";
    /* \\ deliveryInfo 관련 값 예외처리 및 재정의 */

    /* contentInfo 관련 값 예외처리 및 재정의 */
    if (!contentInfo || Object.keys(contentInfo).length < 1) {
      TMON.oApp.htStorage.htStaticData.htDealInfo.contentInfo = {};
    }
    let hideDeliveryBannerInfo = false; // 배송유형 표시 여부
    if (
      TMON.htStaticData.bIsDeliveryDeal &&
      contentInfo &&
      Object.keys(contentInfo).length > 0
    ) {
      ({ hideDeliveryBannerInfo = false } = contentInfo);
    }
    TMON.oApp.htStorage.htStaticData.htDealInfo.contentInfo.hideDeliveryBannerInfo = hideDeliveryBannerInfo;
    /* \\ contentInfo 관련 값 예외처리 및 재정의 */

    // 판매중인 딜인지 판별한 값 저장
    TMON.oApp.htStorage.htStaticData.bIsNowSale =
      moment(TMON.oApp.htStorage.htStaticData.htDealInfo.endDate) -
        moment(TMON.currentTimeTimestamp, "x") >
      0;

    // 업체 정보 내의 값 재정의
    for (const item of localShopList) {
      // phone 필드에 전화번호 외의 정보가 들어있는 경우가 있어 전화번호 추출
      // 다음과 같은 포맷
      // 02-6710-1133
      // 1522-7327 <1055574942 딜>
      // 악어컴퍼니 02-764-8760 <558656786 딜>
      // 02-442-2311~2 <802642774 딜>
      // (02)442-2311
      item.sPhoneNoToCall = item.phone.match(/\(*[0-9-)]+/gim)[0];

      // 길찾기 url 생성
      item.sFindMapUrl =
        TMON.sDevice === "PW"
          ? `http://map.naver.com/index.nhn?menu=route&pathType=1&etext=${
              item.shopName
            }&elng=${item.location.lon}&elat=${item.location.lat}`
          : `http://m.map.naver.com/route.nhn?ename=${item.shopName}&ex=${
              item.location.lon
            }&ey=${item.location.lat}`;
    }

    return ["htStaticData"];
  }

  /**
   * 표현을 위한 배송 정보 객체를 반환
   * TopInfo 영역이 리액트로 개편되면서 관련된 조건은 모두 DeliveryHelper로 빠졌다. 하지만 일부 조건(deliveryBanner 등)이 여기서 계산되고 있어 코드를 남겨두었다.
   * @param {object} deliveryInfo 배송 정보에 대한 정보를 담은 객체
   *  {{
   *      {string} deliveryType
   *          - DD(당일발송), ND(익일발송), ED(예외발송), CD(종료후발송), NONE(NONE)
   *      {string} deliveryProductType
   *          - DP01(냉장/냉동/신선 식품), DP02(해외직배송), DP03(해외구매대행), DP04(화물/설치), DP05(주문제작), DP06(주문 후 발주), DP07(일반상품), DP08(예외상품), NONE(NONE)
   *      {string} deliveryPackage
   *          - DELIVERY, POST(우편배송 여부의 판단을 위해 사용), FREIGHT, NONE
   *      {any} 기타 등등...
   *  }}
   * @param {string} refundType 취소/환불에 대한 정보를 담은 문자
   *      - S(단순 변심 환불 가능), N(단순 변심 환불 불가(DP04일 경우에 있음))
   */
  getRefinedDeliveryInfo = (deliveryInfo, refundType) => {
    /*
     * DECE-1239 개편
     * htRefinedDeliveryInfo 를 사용하는 곳은 현재 딜상세 시점으로 총 네 군데이다.
     * 각각의 장소에서 사용할 텍스트를 최대한 이곳에서 분기한다.
     * 각 모듈에서 상황별 분기를 최대한 줄이는 것이 개선의 목표이다.
     */
    const expectedDeliveryEndDate = TMON.oApp.oUtil.getDayType1(
      deliveryInfo.expectedDeliveryEndDate
    ); // 도착예정일

    const averageDeliveryDays = deliveryInfo.averageDeliveryDays
      ? deliveryInfo.averageDeliveryDays
      : false; // 평균배송일
    const { deliveryProductType } = deliveryInfo;
    const {
      verticalType,
    } = TMON.oApp.htStorage.htStaticData.htDealInfo.categoryInfo;
    const htRefinedDeliveryInfo = {
      bShowDeliveryDateDescription:
        expectedDeliveryEndDate || averageDeliveryDays,
      sDeliveryDateDescriptionOnTooltip: "",
      sDeliveryDateDescription: "",
      title: "",
      sDeliveryBannerButtonDataRole: "",
      icon: "ico_delivery",
      expectedDeliveryEndDate,
      averageDeliveryDays,
      deliveryProductType,
      deliveryKeyword: "",
      deliveryInfo: "",
      deliveryInfoLayer: "",
      deliveryBanner: "",
    };

    if (expectedDeliveryEndDate && averageDeliveryDays) {
      htRefinedDeliveryInfo.sDeliveryDateDescriptionOnTooltip =
        "도착 예정일은 판매자가 설정한 예정일, 평균 배송일은 최근 7일간 평균 배송 소요일입니다.";
      htRefinedDeliveryInfo.sDeliveryDateDescription =
        "도착 예정일은 판매자가 설정한 예정일, 평균 배송일은 최근 7일간 평균 배송 소요일";
    } else if (expectedDeliveryEndDate && !averageDeliveryDays) {
      htRefinedDeliveryInfo.sDeliveryDateDescriptionOnTooltip =
        "판매자가 설정한 배송일로 실제 배송일과 차이가 있을 수 있습니다.";
      htRefinedDeliveryInfo.sDeliveryDateDescription =
        "판매자가 설정한 배송일로 실제 배송일과 차이가 있을 수 있음";
    } else if (!expectedDeliveryEndDate && averageDeliveryDays) {
      htRefinedDeliveryInfo.sDeliveryDateDescriptionOnTooltip =
        "최근 7일간 평균 배송 소요일 입니다.";
      htRefinedDeliveryInfo.sDeliveryDateDescription =
        "최근 7일간 평균 배송 소요일";
    }

    // 당일배송 가능여부 (시간으로 판단)
    const isPossibleDeliveryToday =
      deliveryInfo.theDayDeliveryStartTime &&
      parseInt(TMON.currentTimeString.substr(8), 10) <
        parseInt(deliveryInfo.theDayDeliveryStartTime.replace(/:/g, ""), 10);

    if (!TMON.htStaticData.isPurchaseAvailable) {
      // 구매 가능 상태가 아니면 아무것도 하지 않는다.
    } else if (verticalType === "LOTTE_DEPARTMENT") {
      // 롯데백화점
      htRefinedDeliveryInfo.deliveryInfo =
        '배송일 평균 <span class="brand_color">5</span>일 정도 소요 예정';
      htRefinedDeliveryInfo.deliveryInfoLayer = `
                <li>배송일 평균 <span class="brand_color">5</span>일 정도 소요 예정</li>
                <li>${this.getConditionText(deliveryProductType)}</li>
                <li>${this.getRefundText(refundType)}</li>
                <li>${this.getOrderCancelableText(deliveryInfo)}</li>
            `;
      htRefinedDeliveryInfo.title = "롯데백화점<br>배송";
      htRefinedDeliveryInfo.deliveryBanner = `
                <p>배송일 <strong>평균 5일 정도 소요 예정</strong>입니다.</p>
                <p>${this.getConditionText(deliveryProductType)}</p>
                <p>${this.getRefundText(refundType)}</p>
            `;
    } else if (verticalType === "OUTLET") {
      // 롯데아울렛
      htRefinedDeliveryInfo.deliveryInfo =
        '배송일 평균 <span class="brand_color">5</span>일 정도 소요 예정';
      htRefinedDeliveryInfo.deliveryInfoLayer = `
                <li>배송일 평균 <span class="brand_color">5</span>일 정도 소요 예정</li>
                <li>${this.getConditionText(deliveryProductType)}</li>
                <li>${this.getRefundText(refundType)}</li>
                <li>${this.getOrderCancelableText(deliveryInfo)}</li>
            `;
      htRefinedDeliveryInfo.title = "롯데아울렛<br>배송";
      htRefinedDeliveryInfo.deliveryBanner = `
                <p>배송일 <strong>평균 5일 정도 소요 예정</strong>입니다.</p>
                <p>${this.getConditionText(deliveryProductType)}</p>
                <p>${this.getRefundText(refundType)}</p>
            `;
    } else if (deliveryInfo.deliveryType === "DD") {
      // 당일발송
      htRefinedDeliveryInfo.deliveryInfo = `${
        deliveryInfo.deliveryPackage === "POST"
          ? this.getPostDeliveryInfoText(deliveryInfo, htRefinedDeliveryInfo)
          : `${TMON.oApp.oUtil.getTextWithBar(
              expectedDeliveryEndDate,
              `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`,
              averageDeliveryDays,
              `평균 배송일 <span class="brand_color">${averageDeliveryDays}</span> 일`
            )}`
      }`;
      htRefinedDeliveryInfo.deliveryInfoLayer = `
                ${
                  deliveryInfo.deliveryPackage === "POST"
                    ? this.getPostDeliveryInfoText(
                        deliveryInfo,
                        htRefinedDeliveryInfo,
                        true
                      )
                    : `<li>${TMON.oApp.oUtil.getTextWithBar(
                        expectedDeliveryEndDate,
                        `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`,
                        averageDeliveryDays,
                        `평균 배송일 <span class="brand_color">${averageDeliveryDays}</span> 일`
                      )}</li>`
                }
                <li>${htRefinedDeliveryInfo.sDeliveryDateDescription}</li>
                <li>${this.getConditionText(deliveryProductType)}</li>
                <li>${this.getRefundText(refundType)}</li>
                <li>${this.getOrderCancelableText(deliveryInfo)}</li>
            `;
      htRefinedDeliveryInfo.title = isPossibleDeliveryToday
        ? "당일발송"
        : "익일발송";
      htRefinedDeliveryInfo.deliveryBanner = `
                <p>${
                  expectedDeliveryEndDate
                    ? `지금 구매하시면 <strong><span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정</strong>입니다.`
                    : ""
                }</p>
                <p>${htRefinedDeliveryInfo.sDeliveryDateDescription}</p>
                <p class="info">${this.getConditionText(
                  deliveryProductType
                )}</p>
                <p class="info">${this.getRefundText(refundType)}</p>
            `;
    } else if (deliveryInfo.deliveryType === "ND") {
      // 익일발송
      htRefinedDeliveryInfo.deliveryInfo = `${
        deliveryInfo.deliveryPackage === "POST"
          ? this.getPostDeliveryInfoText(deliveryInfo, htRefinedDeliveryInfo)
          : `${TMON.oApp.oUtil.getTextWithBar(
              expectedDeliveryEndDate,
              `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`,
              averageDeliveryDays,
              `평균 배송일 <span class="brand_color">${averageDeliveryDays}</span> 일`
            )}`
      }`;
      htRefinedDeliveryInfo.deliveryInfoLayer = `
                ${
                  deliveryInfo.deliveryPackage === "POST"
                    ? this.getPostDeliveryInfoText(
                        deliveryInfo,
                        htRefinedDeliveryInfo,
                        true
                      )
                    : `<li>${TMON.oApp.oUtil.getTextWithBar(
                        expectedDeliveryEndDate,
                        `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`,
                        averageDeliveryDays,
                        `평균 배송일 <span class="brand_color">${averageDeliveryDays}</span> 일`
                      )}</li>`
                }
                <li>${htRefinedDeliveryInfo.sDeliveryDateDescription}</li>
                <li>${this.getConditionText(deliveryProductType)}</li>
                <li>${this.getRefundText(refundType)}</li>
                <li>${this.getOrderCancelableText(deliveryInfo)}</li>
            `;
      htRefinedDeliveryInfo.title = "익일발송";
      htRefinedDeliveryInfo.deliveryBanner = `
                <p>${
                  expectedDeliveryEndDate
                    ? `지금 구매하시면 <strong><span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정</strong>입니다.`
                    : ""
                }</p>
                <p>${htRefinedDeliveryInfo.sDeliveryDateDescription}</p>
                <p class="info">${this.getConditionText(
                  deliveryProductType
                )}</p>
                <p class="info">${this.getRefundText(refundType)}</p>
            `;
    } else if (deliveryInfo.deliveryType === "ED") {
      // 예외배송
      htRefinedDeliveryInfo.title = "예외발송";
      switch (deliveryInfo.deliveryProductType) {
        case "DP02":
          htRefinedDeliveryInfo.deliveryKeyword = "해외 직배송";
          htRefinedDeliveryInfo.icon = "ico_overseas";
          htRefinedDeliveryInfo.deliveryInfo = `${
            deliveryInfo.deliveryPackage === "POST"
              ? this.getPostDeliveryInfoText(
                  deliveryInfo,
                  htRefinedDeliveryInfo
                )
              : `${TMON.oApp.oUtil.getTextWithBar(
                  expectedDeliveryEndDate,
                  `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`,
                  averageDeliveryDays,
                  `평균 배송일 <span class="brand_color">${averageDeliveryDays}</span> 일`
                )}`
          }`;
          htRefinedDeliveryInfo.deliveryInfoLayer = `
                        ${
                          deliveryInfo.deliveryPackage === "POST"
                            ? this.getPostDeliveryInfoText(
                                deliveryInfo,
                                htRefinedDeliveryInfo,
                                true
                              )
                            : `<li>${TMON.oApp.oUtil.getTextWithBar(
                                expectedDeliveryEndDate,
                                `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`,
                                averageDeliveryDays,
                                `평균 배송일 <span class="brand_color">${averageDeliveryDays}</span> 일`
                              )}</li>`
                        }
                        <li>${
                          htRefinedDeliveryInfo.sDeliveryDateDescription
                        }</li>
                        <li>${this.getConditionText(deliveryProductType)}</li>
                        <li>${this.getRefundText(
                          refundType,
                          "제품 수령 후 7일 이내 환불 가능 (해외 특송비 별도 부담)"
                        )}</li>
                        <li>해외 배송 상품 특성상 품절로 인한 주문 취소가 발생할 수 있음</li>
                        <li>${this.getOrderCancelableText(deliveryInfo)}</li>
                        <li>본 상품은 해외에서 배송되며 상품에 따라 관부과세가 발생될 수 있음. 동일 수취인, 일일 입항일 기준 물품가격이 US$150(미국 발송 목록통관 기준 US$200)를 초과하는 경우, 구매자에게 관부과세가 부과될 수 있음</li>
                    `;
          htRefinedDeliveryInfo.title = "해외 직배송";
          htRefinedDeliveryInfo.deliveryBanner = `
                        <p>${
                          expectedDeliveryEndDate
                            ? `지금 구매하시면 <strong><span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정</strong>입니다.`
                            : ""
                        }</p>
                        <p>${htRefinedDeliveryInfo.sDeliveryDateDescription}</p>
                        <p class="info">${this.getConditionText(
                          deliveryProductType
                        )}</p>
                        <p class="info">${this.getRefundText(
                          refundType,
                          "제품 수령 후 7일 이내 환불 가능 (해외 특송비 별도 부담)"
                        )}</p>
                        <p class="info">해외 배송 상품 특성상 품절로 인한 주문 취소가 발생할 수 있음</p>
                    `;
          break;
        case "DP03":
          htRefinedDeliveryInfo.deliveryKeyword = "해외 구매대행";
          htRefinedDeliveryInfo.icon = "ico_overseas";
          htRefinedDeliveryInfo.deliveryInfo = `${
            deliveryInfo.deliveryPackage === "POST"
              ? this.getPostDeliveryInfoText(
                  deliveryInfo,
                  htRefinedDeliveryInfo
                )
              : `${TMON.oApp.oUtil.getTextWithBar(
                  expectedDeliveryEndDate,
                  `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`,
                  averageDeliveryDays,
                  `평균 배송일 <span class="brand_color">${averageDeliveryDays}</span> 일`
                )}`
          }`;
          htRefinedDeliveryInfo.deliveryInfoLayer = `
                        ${
                          deliveryInfo.deliveryPackage === "POST"
                            ? this.getPostDeliveryInfoText(
                                deliveryInfo,
                                htRefinedDeliveryInfo,
                                true
                              )
                            : `<li>${TMON.oApp.oUtil.getTextWithBar(
                                expectedDeliveryEndDate,
                                `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`,
                                averageDeliveryDays,
                                `평균 배송일 <span class="brand_color">${averageDeliveryDays}</span> 일`
                              )}</li>`
                        }
                        <li>${
                          htRefinedDeliveryInfo.sDeliveryDateDescription
                        }</li>
                        <li>${this.getConditionText(deliveryProductType)}</li>
                        <li>${this.getRefundText(
                          refundType,
                          "제품 수령 후 7일 이내 환불 가능 (해외 특송비 별도 부담)"
                        )}</li>
                        <li>해외 배송 상품 특성상 품절로 인한 주문 취소가 발생할 수 있음</li>
                        <li>${this.getOrderCancelableText(deliveryInfo)}</li>
                        <li>본 상품은 해외에서 배송되며 상품에 따라 관부과세가 발생될 수 있음. 동일 수취인, 일일 입항일 기준 물품가격이 US$150(미국 발송 목록통관 기준 US$200)를 초과하는 경우, 구매자에게 관부과세가 부과될 수 있음</li>
                    `;
          htRefinedDeliveryInfo.title = "해외 구매대행";
          htRefinedDeliveryInfo.deliveryBanner = `
                        <p>${
                          expectedDeliveryEndDate
                            ? `지금 구매하시면 <strong><span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정</strong>입니다.`
                            : ""
                        }</p>
                        <p>${htRefinedDeliveryInfo.sDeliveryDateDescription}</p>
                        <p class="info">${this.getConditionText(
                          deliveryProductType
                        )}</p>
                        <p class="info">${this.getRefundText(
                          refundType,
                          "제품 수령 후 7일 이내 환불 가능 (해외 특송비 별도 부담)"
                        )}</p>
                        <p class="info">해외 배송 상품 특성상 품절로 인한 주문 취소가 발생할 수 있음</p>
                    `;
          break;
        case "DP04":
          htRefinedDeliveryInfo.bShowDeliveryDateDescription = false;
          htRefinedDeliveryInfo.deliveryInfo = "상품설명 내 배송일정 안내";
          htRefinedDeliveryInfo.deliveryInfoLayer = `
                        <li>상품설명 내 배송일정 안내</li>
                        <li>${this.getConditionText(deliveryProductType)}</li>
                        <li>${this.getRefundText(
                          refundType,
                          "제품 수령 후 7일 이내 환불 가능 (반품비 별도 부담)"
                        )}</li>
                        <li>${this.getOrderCancelableText(deliveryInfo)}</li>
                    `;
          htRefinedDeliveryInfo.title = "지정일 발송";
          htRefinedDeliveryInfo.deliveryBanner = `
                        <p><strong>상품설명 내 배송일정 안내</strong>되어 있습니다.</p>
                        <p class="info">${this.getConditionText(
                          deliveryProductType
                        )}</p>
                        <p class="info">${this.getRefundText(
                          refundType,
                          "제품 수령 후 7일 이내 환불 가능 (반품비 별도 부담)"
                        )}</p>
                    `;
          break;
        case "DP05":
          htRefinedDeliveryInfo.deliveryInfo = `${
            deliveryInfo.deliveryPackage === "POST"
              ? this.getPostDeliveryInfoText(
                  deliveryInfo,
                  htRefinedDeliveryInfo
                )
              : `${TMON.oApp.oUtil.getTextWithBar(
                  expectedDeliveryEndDate,
                  `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`,
                  averageDeliveryDays,
                  `평균 배송일 <span class="brand_color">${averageDeliveryDays}</span> 일`
                )}`
          }`;
          htRefinedDeliveryInfo.deliveryInfoLayer = `
                        ${
                          deliveryInfo.deliveryPackage === "POST"
                            ? this.getPostDeliveryInfoText(
                                deliveryInfo,
                                htRefinedDeliveryInfo,
                                true
                              )
                            : `<li>${TMON.oApp.oUtil.getTextWithBar(
                                expectedDeliveryEndDate,
                                `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`,
                                averageDeliveryDays,
                                `평균 배송일 <span class="brand_color">${averageDeliveryDays}</span> 일`
                              )}</li>`
                        }
                        <li>${
                          htRefinedDeliveryInfo.sDeliveryDateDescription
                        }</li>
                        <li>${this.getConditionText(deliveryProductType)}</li>
                        <li>${this.getRefundText(refundType)}</li>
                        <li>${this.getOrderCancelableText(deliveryInfo)}</li>
                    `;
          htRefinedDeliveryInfo.title = "지정일 발송";
          htRefinedDeliveryInfo.deliveryBanner = `
                        <p>${
                          expectedDeliveryEndDate
                            ? `지금 구매하시면 <strong><span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정</strong>입니다.`
                            : ""
                        }</p>
                        <p>${htRefinedDeliveryInfo.sDeliveryDateDescription}</p>
                        <p class="info">${this.getConditionText(
                          deliveryProductType
                        )}</p>
                        <p class="info">${this.getRefundText(refundType)}</p>
                    `;
          break;
        case "DP06":
          htRefinedDeliveryInfo.deliveryInfo = `${
            deliveryInfo.deliveryPackage === "POST"
              ? this.getPostDeliveryInfoText(
                  deliveryInfo,
                  htRefinedDeliveryInfo
                )
              : `${TMON.oApp.oUtil.getTextWithBar(
                  expectedDeliveryEndDate,
                  `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`,
                  averageDeliveryDays,
                  `평균 배송일 <span class="brand_color">${averageDeliveryDays}</span> 일`
                )}`
          }`;
          htRefinedDeliveryInfo.deliveryInfoLayer = `
                        ${
                          deliveryInfo.deliveryPackage === "POST"
                            ? this.getPostDeliveryInfoText(
                                deliveryInfo,
                                htRefinedDeliveryInfo,
                                true
                              )
                            : `<li>${TMON.oApp.oUtil.getTextWithBar(
                                expectedDeliveryEndDate,
                                `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`,
                                averageDeliveryDays,
                                `평균 배송일 <span class="brand_color">${averageDeliveryDays}</span> 일`
                              )}</li>`
                        }
                        <li>${
                          htRefinedDeliveryInfo.sDeliveryDateDescription
                        }</li>
                        <li>${this.getConditionText(deliveryProductType)}</li>
                        <li>${this.getRefundText(refundType)}</li>
                        <li>${this.getOrderCancelableText(deliveryInfo)}</li>
                    `;
          htRefinedDeliveryInfo.title = "지정일 발송";
          htRefinedDeliveryInfo.deliveryBanner = `
                        <p>${
                          expectedDeliveryEndDate
                            ? `지금 구매하시면 <strong><span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정</strong>입니다.`
                            : ""
                        }</p>
                        <p>${htRefinedDeliveryInfo.sDeliveryDateDescription}</p>
                        <p class="info">${this.getConditionText(
                          deliveryProductType
                        )}</p>
                        <p class="info">${this.getRefundText(refundType)}</p>
                    `;
          break;
        default:
          break;
      }
    } else if (deliveryInfo.deliveryType === "CD") {
      // 종료후발송
      htRefinedDeliveryInfo.title = "종료 후 발송";
      switch (deliveryInfo.deliveryProductType) {
        case "DP01":
          htRefinedDeliveryInfo.bShowDeliveryDateDescription = false;
          htRefinedDeliveryInfo.deliveryInfo = "판매종료 후 순차 발송";
          htRefinedDeliveryInfo.deliveryInfoLayer = `
                        <li>판매 종료 후 순차 발송</li>
                        <li>${this.getConditionText(deliveryProductType)}</li>
                        <li>${this.getRefundText(refundType)}</li>
                        <li>${this.getOrderCancelableText(deliveryInfo)}</li>
                    `;
          htRefinedDeliveryInfo.deliveryBanner = `
                        <p><strong>판매종료 후 순차 발송됩니다.</strong></p>
                        <p class="info">${this.getConditionText(
                          deliveryProductType
                        )}</p>
                        <p class="info">${this.getRefundText(refundType)}</p>
                    `;
          break;
        case "DP02":
          htRefinedDeliveryInfo.deliveryKeyword = "해외 직배송";
          htRefinedDeliveryInfo.deliveryInfo = expectedDeliveryEndDate
            ? `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`
            : "";
          htRefinedDeliveryInfo.deliveryInfoLayer = `
                        <li>${
                          expectedDeliveryEndDate
                            ? `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`
                            : ""
                        }</li>
                        <li>도착 예정일은 판매자가 설정한 배송일로 실제 배송일과 차이가 있을 수 있음</li>
                        <li>${this.getConditionText(deliveryProductType)}</li>
                        <li>${this.getRefundText(
                          refundType,
                          "제품 수령 후 7일 이내 환불 가능 (해외 특송비 별도 부담)"
                        )}</li>
                        <li>해외 배송 상품 특성상 품절로 인한 주문 취소가 발생할 수 있음</li>
                        <li>${this.getOrderCancelableText(deliveryInfo)}</li>
                        <li>본 상품은 해외에서 배송되며 상품에 따라 관부과세가 발생될 수 있음. 동일 수취인, 일일 입항일 기준 물품가격이 US$150(미국 발송 목록통관 기준 US$200)를 초과하는 경우, 구매자에게 관부과세가 부과될 수 있음</li>
                    `;
          htRefinedDeliveryInfo.title = "해외 직배송";
          htRefinedDeliveryInfo.deliveryBanner = `
                        <p>${
                          expectedDeliveryEndDate
                            ? `<strong>판매 종료 후 <span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정</strong>입니다.`
                            : ""
                        }</p>
                        <p>도착 예정일은 판매자가 설정한 배송일로 실제 배송일과 차이가 있을 수 있음</p>
                        <p class="info">${this.getConditionText(
                          deliveryProductType
                        )}</p>
                        <p class="info">${this.getRefundText(
                          refundType,
                          "제품 수령 후 7일 이내 환불 가능 (해외 특송비 별도 부담)"
                        )}</p>
                        <p class="info">해외 배송 상품 특성상 품절로 인한 주문 취소가 발생할 수 있음</p>
                    `;
          break;
        case "DP03":
          htRefinedDeliveryInfo.deliveryKeyword = "해외 구매대행";
          htRefinedDeliveryInfo.deliveryInfo = expectedDeliveryEndDate
            ? `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`
            : "";
          htRefinedDeliveryInfo.deliveryInfoLayer = `
                    <li>${
                      expectedDeliveryEndDate
                        ? `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`
                        : ""
                    }</li>
                        <li>도착 예정일은 판매자가 설정한 배송일로 실제 배송일과 차이가 있을 수 있음</li>
                        <li>${this.getConditionText(deliveryProductType)}</li>
                        <li>${this.getRefundText(
                          refundType,
                          "제품 수령 후 7일 이내 환불 가능 (해외 특송비 별도 부담)"
                        )}</li>
                        <li>해외 배송 상품 특성상 품절로 인한 주문 취소가 발생할 수 있음</li>
                        <li>${this.getOrderCancelableText(deliveryInfo)}</li>
                        <li>본 상품은 해외에서 배송되며 상품에 따라 관부과세가 발생될 수 있음. 동일 수취인, 일일 입항일 기준 물품가격이 US$150(미국 발송 목록통관 기준 US$200)를 초과하는 경우, 구매자에게 관부과세가 부과될 수 있음</li>
                    `;
          htRefinedDeliveryInfo.title = "해외 구매대행";
          htRefinedDeliveryInfo.deliveryBanner = `
                        <p>${
                          expectedDeliveryEndDate
                            ? `<strong>판매 종료 후 <span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정</strong>입니다.`
                            : ""
                        }</p>
                        <p>도착 예정일은 판매자가 설정한 배송일로 실제 배송일과 차이가 있을 수 있음</p>
                        <p class="info">${this.getConditionText(
                          deliveryProductType
                        )}</p>
                        <p class="info">${this.getRefundText(
                          refundType,
                          "제품 수령 후 7일 이내 환불 가능 (해외 특송비 별도 부담)"
                        )}</p>
                        <p class="info">해외 배송 상품 특성상 품절로 인한 주문 취소가 발생할 수 있음</p>
                    `;
          break;
        case "DP04":
          htRefinedDeliveryInfo.bShowDeliveryDateDescription = false;
          htRefinedDeliveryInfo.deliveryInfo = "상품설명 내 배송일정 안내";
          htRefinedDeliveryInfo.deliveryInfoLayer = `
                        <li>상품설명 내 배송일정 안내</li>
                        <li>${this.getConditionText(deliveryProductType)}</li>
                        <li>${this.getRefundText(
                          refundType,
                          "제품 수령 후 7일 이내 환불 가능 (반품비 별도 부담)"
                        )}</li>
                        <li>${this.getOrderCancelableText(deliveryInfo)}</li>
                    `;
          htRefinedDeliveryInfo.deliveryBanner = `
                        <p><strong>상품설명 내 배송일정 안내</strong>되어 있습니다.</p>
                        <p class="info">${this.getConditionText(
                          deliveryProductType
                        )}</p>
                        <p class="info">${this.getRefundText(
                          refundType,
                          "제품 수령 후 7일 이내 환불 가능 (반품비 별도 부담)"
                        )}</p>
                    `;
          break;
        case "DP05":
          htRefinedDeliveryInfo.deliveryInfo = expectedDeliveryEndDate
            ? `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`
            : "";
          htRefinedDeliveryInfo.deliveryInfoLayer = `
                        <li>${
                          expectedDeliveryEndDate
                            ? `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`
                            : ""
                        }</li>
                        <li>도착 예정일은 판매자가 설정한 배송일로 실제 배송일과 차이가 있을 수 있음</li>
                        <li>${this.getConditionText(deliveryProductType)}</li>
                        <li>${this.getRefundText(refundType)}</li>
                        <li>${this.getOrderCancelableText(deliveryInfo)}</li>
                    `;
          htRefinedDeliveryInfo.deliveryBanner = `
                        <p>${
                          expectedDeliveryEndDate
                            ? `<strong>판매 종료 후 <span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정</strong>입니다.`
                            : ""
                        }</p>
                        <p>도착 예정일은 판매자가 설정한 배송일로 실제 배송일과 차이가 있을 수 있음</p>
                        <p class="info">${this.getConditionText(
                          deliveryProductType
                        )}</p>
                        <p class="info">${this.getRefundText(refundType)}</p>
                    `;
          break;
        case "DP06":
          htRefinedDeliveryInfo.deliveryInfo = expectedDeliveryEndDate
            ? `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`
            : "";
          htRefinedDeliveryInfo.deliveryInfoLayer = `
                        <li>${
                          expectedDeliveryEndDate
                            ? `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`
                            : ""
                        }</li>
                        <li>도착 예정일은 판매자가 설정한 배송일로 실제 배송일과 차이가 있을 수 있음</li>
                        <li>${this.getConditionText(deliveryProductType)}</li>
                        <li>${this.getRefundText(refundType)}</li>
                        <li>${this.getOrderCancelableText(deliveryInfo)}</li>
                    `;
          htRefinedDeliveryInfo.deliveryBanner = `
                        <p>${
                          expectedDeliveryEndDate
                            ? `<strong>판매 종료 후 <span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정</strong>입니다.`
                            : ""
                        }</p>
                        <p>도착 예정일은 판매자가 설정한 배송일로 실제 배송일과 차이가 있을 수 있음</p>
                        <p class="info">${this.getConditionText(
                          deliveryProductType
                        )}</p>
                        <p class="info">${this.getRefundText(refundType)}</p>
                    `;
          break;
        case "DP07":
          htRefinedDeliveryInfo.deliveryInfo = expectedDeliveryEndDate
            ? `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`
            : "";
          htRefinedDeliveryInfo.deliveryInfoLayer = `
                        <li>${
                          expectedDeliveryEndDate
                            ? `<span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정`
                            : ""
                        }</li>
                        <li>도착 예정일은 판매자가 설정한 배송일로 실제 배송일과 차이가 있을 수 있음</li>
                        <li>${this.getConditionText(deliveryProductType)}</li>
                        <li>${this.getRefundText(refundType)}</li>
                        <li>${this.getOrderCancelableText(deliveryInfo)}</li>
                    `;
          htRefinedDeliveryInfo.deliveryBanner = `
                        <p>${
                          expectedDeliveryEndDate
                            ? `<strong>판매 종료 후 <span class="brand_color">${expectedDeliveryEndDate}</span> 이내 도착 예정</strong>입니다.`
                            : ""
                        }</p>
                        <p>도착 예정일은 판매자가 설정한 배송일로 실제 배송일과 차이가 있을 수 있음</p>
                        <p class="info">${this.getConditionText(
                          deliveryProductType
                        )}</p>
                        <p class="info">${this.getRefundText(refundType)}</p>
                    `;
          break;
        default:
          break;
      }
    }

    htRefinedDeliveryInfo.deliveryInfoLayer = htRefinedDeliveryInfo.deliveryInfoLayer.replace(
      /<li><\/li>/gi,
      ""
    );
    htRefinedDeliveryInfo.deliveryBanner = htRefinedDeliveryInfo.deliveryBanner.replace(
      /<p><\/p>/gi,
      ""
    );
    return htRefinedDeliveryInfo;
  };

  /**
   * 취소조건 텍스트
   */
  getOrderCancelableText = ({ deliveryProductType, deliverySpotType }) => {
    let sOrderCancelableText = "";
    if (deliverySpotType === "DIRECT" || deliverySpotType === "LT01") {
      sOrderCancelableText =
        '"결제완료" 상태일 때까지만 즉시 취소 가능. “상품 준비 중” 상태부터는 "취소요청"만 가능';
    } else if (
      (deliverySpotType === "TMON4" ||
        deliverySpotType === "TMON6" ||
        deliverySpotType === "TMON7" ||
        deliverySpotType === "TMON8" ||
        deliverySpotType === "TMON9" ||
        deliverySpotType === "TMON10") &&
      (deliveryProductType === "DP01" ||
        deliveryProductType === "DP07" ||
        deliveryProductType === "DP08")
    ) {
      sOrderCancelableText = `"상품 준비 중" 상태일 때까지만 즉시 취소 가능. "배송 준비 중" 상태부터는 "취소요청"만 가능`;
    }
    return sOrderCancelableText;
  };

  /**
   * 발송 조건 문자열을 반환
   * @param {string} deliveryProductType
   */
  getConditionText = (deliveryProductType) => {
    const conditionText =
      deliveryProductType === "DP01"
        ? "금요일/주말/공휴일과 겹칠 경우 다음 영업일에 발송"
        : "주말/공휴일과 겹칠 경우 다음 영업일에 발송";
    return conditionText;
  };

  /**
   * 단순변심 환불 가능 여부에 따른 환불 정책 문자열을 반환
   * @param {string} refundType 취소/환불에 대한 정보를 담은 문자
   */
  getRefundText = (refundType, changeText) => {
    let refundText = "";
    if (refundType === "S") {
      // 단순 변심 환불 가능
      if (changeText) {
        refundText = changeText;
      } else {
        refundText = "제품수령 후 7일 이내 환불 가능";
      }
    } else if (refundType === "N") {
      // 단순 변심 환불 불가
      refundText = "단순변심 환불 불가";
    }
    return refundText;
  };

  /**
   * 배송 정책에 따른 배송비 표시 문자열을 반환
   * @param {object} deliveryInfo 배송 정보에 대한 정보를 담은 객체
   *  {{
   *      {string} deliveryFeePolicy
   *          - FREE(무료배송), PER(선결제), CONDITION(조건부 무료배송), AFTER(착불), NONE(NONE)
   *  }}
   */
  getRefinedDeliveryFeePolicy = (deliveryInfo) => {
    switch (deliveryInfo.deliveryFeePolicy) {
      case "FREE":
        return "무료배송";
      case "PER":
        if (deliveryInfo.deliveryFee > 0) {
          return `배송비 선불 ${TMON.util.numberFormat(
            deliveryInfo.deliveryFee
          )}원`;
        }
        return "배송비 선불 (컨텐츠 참고)";
      case "AFTER":
        if (deliveryInfo.deliveryFee > 0) {
          return `배송비 착불 ${TMON.util.numberFormat(
            deliveryInfo.deliveryFee
          )}원`;
        }
        return "배송비 착불 (컨텐츠 참고)";
      case "CONDITION":
        if (deliveryInfo.deliveryFee > 0) {
          return `
                        <span>
                            ${TMON.util.numberFormat(
                              deliveryInfo.deliveryFee
                            )}원
                            <span class="txt_bar bar"></span>
                            ${TMON.util.numberFormat(
                              deliveryInfo.minTotalPaidForFreeDelivery
                            )}원 이상 구매 시 무료배송
                        </span>
                    `;
        }
        return "조건부무료배송 (컨텐츠 참고)";
      default:
        return "";
    }
  };

  /**
   * 우편 배송 추가 선택시 우편배송 관련 안내 html 문자열을 반환
   * @param {object} deliveryInfo 배송 정보에 대한 정보를 담은 객체
   * @param {object} htRefinedDeliveryInfo 가공된 배송 정보를 담은 객체
   * @param {boolean} isLayerPopup 레이어 팝업 여부
   * {{
   *      {string} 우편 배송 안내 html 문자열
   * }}
   */
  getPostDeliveryInfoText(
    deliveryInfo,
    htRefinedDeliveryInfo,
    isLayerPopup = false
  ) {
    let result = "";
    const pType = deliveryInfo.postCriticalType === "A" ? "원" : "개";
    const deliveryInfoText = {
      info: `${deliveryInfo.postCriticalValue}${pType} 이하 우편배송 / ${
        deliveryInfo.postCriticalValue
      }${pType} 초과 택배배송`,
      package: `[택배배송] ${TMON.oApp.oUtil.getTextWithBar(
        htRefinedDeliveryInfo.expectedDeliveryEndDate,
        `<span class="brand_color">${
          htRefinedDeliveryInfo.expectedDeliveryEndDate
        }</span> 이내 도착 예정`,
        htRefinedDeliveryInfo.averageDeliveryDays,
        `평균 배송일 <span class="brand_color">${
          htRefinedDeliveryInfo.averageDeliveryDays
        }</span> 일`
      )}`,
      post: `[우편배송] ${TMON.oApp.oUtil.getTextWithBar(
        htRefinedDeliveryInfo.expectedDeliveryEndDate,
        `<span class="brand_color">${
          htRefinedDeliveryInfo.expectedDeliveryEndDate
        }</span> 이내 발송 예정`,
        true,
        '발송 후 <span class="brand_color">3~15</span>영업일 배송소요'
      )}`,
      tooltip: `<div class="default_tip"><a href="javascript:return false;" class="btn_help_tip">배송 정보</a><div class="pop_tooltip_sale"><div class="inner"><p class="txt">${
        htRefinedDeliveryInfo.sDeliveryDateDescriptionOnTooltip
      }</p></div></div></div>`,
      none:
        '우편배송 가능 상품<span class="txt_bar bar"></span>발송 후 <span class="brand_color">3~15</span>영업일 배송소요',
    };
    const isShowTooltip =
      TMON.oApp.sPlatform === "PW" &&
      htRefinedDeliveryInfo.bShowDeliveryDateDescription;

    // 도착예정일, 평균배송소요일 유무 분기 처리
    if (htRefinedDeliveryInfo.bShowDeliveryDateDescription) {
      result += `${
        isLayerPopup
          ? `<li>${deliveryInfoText.info}</li>`
          : `<p class="font_bold">${deliveryInfoText.info}</p>`
      }`;
      result += `${
        isLayerPopup
          ? `<li>${deliveryInfoText.package}</li>`
          : `<div class="delivery_date"><strong>${
              deliveryInfoText.package
            }</strong> ${isShowTooltip ? deliveryInfoText.tooltip : ""}</div>`
      }`;
      result += `${
        isLayerPopup
          ? `<li>${deliveryInfoText.post}</li>`
          : `<div class="delivery_date"><strong>${
              deliveryInfoText.post
            }</strong></div>`
      }`;
    } else {
      result += `${
        isLayerPopup
          ? `<li>${deliveryInfoText.none}</li>`
          : `<div class="delivery_date"><strong>${
              deliveryInfoText.none
            }</strong></div>`
      }`;
    }

    return result;
  }

  /**
   * 카드 이벤트 값을 가공·처리(값이 없을 때 예외처리)
   */
  getCardDiscount() {
    if (!TMON.oApp.htStorage.cardDiscount.data) {
      TMON.oApp.htStorage.cardDiscount.data = [];
    }
    return ["cardDiscount"];
  }

  /**
   * 무이자 할부 안내 값을 가공·처리(값이 없을 때 예외처리)
   */
  getCardMonthlyFree() {
    if (!TMON.oApp.htStorage.cardMonthlyFree.data) {
      TMON.oApp.htStorage.cardMonthlyFree.data = {};
    }
    return ["cardMonthlyFree"];
  }

  /**
   * 상품문의 값을 가공·처리(값이 없을 때 예외처리)
   */
  getQnaList() {
    if (!TMON.oApp.htStorage.qnaList.data.talkList) {
      TMON.oApp.htStorage.qnaList.data.talkList = [];
    }
    if (!TMON.oApp.htStorage.qnaList.data.noticeList) {
      TMON.oApp.htStorage.qnaList.data.noticeList = [];
    }
    if (!TMON.oApp.htStorage.qnaList.data.totalCount) {
      TMON.oApp.htStorage.qnaList.data.totalCount = 0;
    }
    if (!TMON.oApp.htStorage.qnaList.data.noticeCount) {
      TMON.oApp.htStorage.qnaList.data.noticeCount = 0;
    }
    return ["qnaList"];
  }

  /**
   * optionTree 값을 가공·처리
   */
  getOptionTree() {
    const { optionInfo, optionTree } = TMON.oApp.htStorage;
    const { data, callParam } = optionTree;
    if (!data) return ["optionTree"];

    const { dataList, titles, totalDepth } = data;
    const { parentKey, optDealSrl } = callParam.data;
    const depth = callParam.data.depth || 1;

    if (optDealSrl) return ["optionTree"];

    if (!optionInfo) {
      TMON.oApp.htStorage.optionInfo = {
        titles,
        options: [],
        parentKeys: [],
        totalDepth,
      };
    }

    /**
     * TMON.oApp.htStorage.optionInfo 값 가공·처리
     */
    if (dataList) {
      TMON.oApp.htStorage.optionInfo.options[depth - 1] = dataList.map(
        (option) => {
          const { key, value, lastOptNos, dealMax, discount, price } = option;
          return {
            key,
            value,
            parentKey,
            dealMax,
            price,
            discount,
            lastOptNos,
          };
        }
      );
    }

    if (parentKey) {
      TMON.oApp.htStorage.optionInfo.parentKeys.push(parentKey);
    }

    // 1depth일 경우에 optionTree 값 가공
    if (TMON.oApp.htStorage.optionTree.data && depth === 1) {
      // 단일 옵션 여부 설정
      let bOnlyOption = false;
      if (
        totalDepth === 1 &&
        dataList &&
        dataList.length === 1 &&
        dataList[0].lastOptNos.length === 1
      ) {
        bOnlyOption = true;
      }
      TMON.oApp.htStorage.optionInfo.isOnlyOption = bOnlyOption;
      if (TMON.oApp.htStorage.optionInfo.isOnlyOption) {
        TMON.oApp.htStorage.optionInfo.onlyOptionSrl =
          dataList[0].lastOptNos[0];
      }

      TMON.oApp.htStorage.optionInfo.nCalendarDepth = -1;
      // 달력 UI를 사용해야하는 딜일 때, optionTree의 타이틀 검증을 통해 달력 UI를 쓰지 말지 다시 한번 검증한다.
      if (
        !isNaN(
          parseInt(TMON.oApp.htStorage.htStaticData.htDealInfo.calenderInfo, 10)
        )
      ) {
        // 캘린더 선택 UI는 첫 번째 dep || 마지막 dep 에 위치한다.
        const nCalendarDepth =
          parseInt(
            TMON.oApp.htStorage.htStaticData.htDealInfo.calenderInfo,
            10
          ) === 0
            ? 0
            : TMON.oApp.htStorage.optionInfo.totalDepth - 1;
        TMON.oApp.htStorage.optionInfo.nCalendarDepth = nCalendarDepth;
      }

      /**
       * isAvailableOptionSelect
       * 해당 딜에서 purchase selector 를 조작할 수 있는지 없는지 여부
       * purchase selector 를 조작할 수 없다는 말은 :
       * 1) selector 자체가 렌더링될 필요가 없음 v
       * 2) 새로운 상품을 추가하는 것이 불가능하므로 inner cart 에서 아이템을 삭제할 수 없음 (삭제버튼 렌더링해서는 안됨) v
       * 3) 실제 카트에 상품을 담은 뒤에도 inner cart 에서 아이템을 삭제해서는 안됨 v
       *
       * [ABTest][DECE-2228]
       * TMON.oApp.htStorage.htStaticData.isChangeableOption === true 일 때 : 옵션딜일 때 isAvailableOptionSelect 를 false 로 만들지 않는다.
       * TMON.oApp.htStorage.htStaticData.isChangeableOption !== true 일 때 : 옵션딜일 때 isAvailableOptionSelect 를 false 로 만든다.
       */
      TMON.oApp.htStorage.optionInfo.isAvailableOptionSelect = true;
      const { isOnlyOption } = TMON.oApp.htStorage.optionInfo; // 해당 딜에 옵션이 하나인지에 대한 여부
      if (isOnlyOption) {
        TMON.oApp.htStorage.optionInfo.isAvailableOptionSelect = false;
      } // 옵션이 하나밖에 없는 딜은 selector 를 그리지 않는다. 다른 옵션을 담을 수가 없기 때문에 있을 필요가 없음.

      if (!TMON.oApp.htStorage.htStaticData.isChangeableOption) {
        const { bDetailviewAvailable } = TMON.htStaticData; // 옵션 자세히보기 가능여부
        const { bOptionDeal } = TMON.oApp.htStorage.htStaticData; // 옵션딜 여부 (option_deal_srl 파라메터 유무로 판단)
        if (bOptionDeal && bDetailviewAvailable && totalDepth === 1) {
          TMON.oApp.htStorage.optionInfo.isAvailableOptionSelect = false;
        } // 옵션 자세히보기 가능하면서 totalDepth 가 1인 경우
      }
    }

    return ["optionTree"];
  }

  /**
   * optionList 값을 가공·처리(값이 없을 때 예외처리)
   */
  getOptionList() {
    if (
      TMON.oApp.htStorage.optionList.data &&
      TMON.oApp.htStorage.optionList.data.length > 0
    ) {
      TMON.oApp.htStorage.optionList.htRefined = {};
      TMON.oApp.htStorage.optionList.data.forEach((htItem) => {
        try {
          TMON.oApp.htStorage.optionList.htRefined[htItem.optionNo] = htItem;
        } catch (e) {
          console.error("ERROR LOG", e);
        }
      });
    }
    return ["optionList"];
  }

  /**
   * 결제수단 커스텀 확인 값을 가공·처리
   * 응답 값이 있을 때 “ methodLimit: "CHTPAKOaB" ” 값을 구분하여 판단
   * 응답 문자열에 아래의 값이 포함 된 경우 해당 결제수단은 사용 불가
   * O(페이코 사용불가), A(티몬페이 사용불가)
   */
  getPayCustomDeals() {
    const { payCustomDeals } = TMON.oApp.htStorage.payCustomDeals.data;

    let bIsPayco = false;
    let bIsTmonPay = false;

    if (
      payCustomDeals &&
      payCustomDeals.length > 0 &&
      payCustomDeals[0].methodLimit
    ) {
      bIsPayco = payCustomDeals[0].methodLimit.indexOf("O") < 0;
      bIsTmonPay = payCustomDeals[0].methodLimit.indexOf("A") < 0;
    }

    TMON.oApp.htStorage.payCustomDeals.data.bIsPayco = bIsPayco;
    TMON.oApp.htStorage.payCustomDeals.data.bIsTmonPay = bIsTmonPay;

    return ["payCustomDeal"];
  }

  getLowAccessibilityAll() {
    const aList = TMON.oApp.getStorage("lowAccessibilityAll").data.list;
    const aRefineList = [];
    for (let i = 0; aList.length > i; i += 1) {
      const item = aList[i];
      aRefineList.push(
        `${item.zipCode} ${item.siDo ? item.siDo : ""} ${
          item.siGuGun ? item.siGuGun : ""
        } ${item.eupMyeonDong ? item.eupMyeonDong : ""} ${
          item.riName ? item.riName : ""
        } ${item.roadName ? item.roadName : ""}`
      );
    }
    TMON.oApp.setStorage("lowAccessibilityAllList", aRefineList);
  }

  getRefineData(sStorageKey) {
    switch (sStorageKey) {
      case "htStaticData":
        return this.getStaticData();
      case "cardDiscount":
        return this.getCardDiscount();
      case "cardMonthlyFree":
        return this.getCardMonthlyFree();
      case "qnaList":
        return this.getQnaList();
      case "optionTree":
        return this.getOptionTree();
      case "optionList":
        return this.getOptionList();
      case "payCustomDeal":
        return this.getPayCustomDeals();
      case "lowAccessibilityAll":
        return this.getLowAccessibilityAll();
      default:
        return [sStorageKey];
    }
  }
}
